import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { ExternalLinkIcon } from 'lucide-react'

import { AttachmentType } from '@/_gql/graphql'

import { queryUserAttachment } from '@/services/user/query'

import { Button } from '@/components/ui/button'
import { KeyValue } from '@/components/ui/key-value'

import { formatMonthYear, normalizeEnum } from '@/lib/utils/utils'

export const Route = createFileRoute('/dashboard/license')({
  component: RouteComponent,
})

function RouteComponent() {
  const certificatesQry = useSuspenseQuery(queryUserAttachment())
  const certificates = certificatesQry.data?.filter(
    (a) => normalizeEnum(a.attachment_type) !== AttachmentType.Resume
  )

  const noRecords = !certificates?.length
  return (
    <div className="rounded-lg border-t-4 border-yes-600 bg-background">
      <div className="border-b px-4 py-4">
        <h2 className="font-semibold">Lisensi / Sertifikat</h2>
      </div>
      {noRecords && (
        <div className="py-12 text-center">
          <h3 className="mb-2 text-xl font-semibold text-gray-600">
            Belum ada lisensi / sertifikat
          </h3>
          <p className="mb-6 text-gray-500">
            Anda belum memiliki lisensi / sertifikat
          </p>
          <Button>
            <Link to="/profile/licences" className="flex items-center gap-2">
              Tambah Lisensi / Sertifikat
            </Link>
          </Button>
        </div>
      )}
      <div className="divide-y divide-gray-200 px-4">
        {certificates?.map(
          ({ id, attachment_type, name, url, start_date, end_date }) => {
            return (
              <div key={id} className="grid grid-cols-2 gap-4 py-4">
                <KeyValue
                  label="Judul Sertifikasi"
                  value={name || '-'}
                  className="col-span-full"
                />
                <KeyValue
                  label="Tanggal Terbit Sertifikat"
                  value={start_date ? formatMonthYear(start_date) : '-'}
                  className="col-span-full"
                />
                <KeyValue
                  label="Tanggal Kadaluarsa Sertifikat"
                  value={end_date ? formatMonthYear(end_date) : '-'}
                  className="col-span-full"
                />
                <KeyValue
                  label="Dokumen Pendukung"
                  value={
                    url ? (
                      <a
                        href={url}
                        target="_blank"
                        className="flex items-center gap-2 underline underline-offset-2"
                      >
                        <ExternalLinkIcon size={16} className="shrink-0" />
                        <span className="line-clamp-1 text-ellipsis">
                          {url}
                        </span>
                      </a>
                    ) : (
                      '-'
                    )
                  }
                  className="col-span-full"
                />
              </div>
            )
          }
        )}
      </div>
    </div>
  )
}
